export default __webpack_public_path__ + "static/how-outsource-design-process-help-your-business-prosper_-957600aa161855a4897e97574b52b33f.png";